import { render, staticRenderFns } from "./LiveProperty.vue?vue&type=template&id=06f05274&"
import script from "./LiveProperty.vue?vue&type=script&lang=js&"
export * from "./LiveProperty.vue?vue&type=script&lang=js&"
import style0 from "./LiveProperty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports